import { FormikValues } from "formik";
import { Dropdown } from "primereact/dropdown";
import { SelectItem } from "primereact/selectitem";
import { getFormErrorMessage } from "../../utils/formHelper";

type Props = {
    disabled: boolean;
    formik: FormikValues;
    label: string;
    options: SelectItem[];
    value: string;
}

export const FormDropdown = (props: Props) => {
    const { disabled, formik, label, options, value } = props;

    return (
        <div className="field">
            <span className="p-float-label">
                <Dropdown id={value} name={value} value={formik.values[value]} disabled={disabled}
                    onChange={formik.handleChange} options={options} className="w-full" scrollHeight="400px" />
                <label htmlFor={value}>{label}</label>
            </span>
            {getFormErrorMessage(value, formik)}
        </div>
    )
}